import SiteSearchResultsSummary from './SiteSearchResultsSummary';

export { type SiteSearchResultsSummaryProps } from './SiteSearchResultsSummary';
export default SiteSearchResultsSummary;
